const en = {
  // ======================================
  // NAVBAR
  // ======================================
  "navbar.phone": "📞 Helpline: +91 9876543210",
  "navbar.email": "✉ chdredgaon@gmail.com",
  "navbar.adminLogin": "Admin Login",
  "navbar.digitalPortal": "Digital Services Portal",

  "nav.home": "Home",
  "nav.adminCommittee": "Admin Committee",
  "nav.citizenPortal": "Citizen Portal",
  "nav.smartVillage": "Smart Village",
  "nav.rti": "RTI",
  "nav.grievance": "Grievance",
  "nav.activity": "Activities",
  "nav.aboutus": "About Us",
  "nav.digitalLibrary": "Digital Library",
  "nav.schemes": "Government Schemes",
  "nav.allNews": "All News",
 

  "nav.otherCommittees":
  "Other Committees",

"otherCommittees.vhnwsc":
  "Village Health Nutrition Water Supply & Sanitation Committee",

"otherCommittees.vwssc":
  "Village Water Supply & Sanitation Committee",
  
  "otherCommittees.vcpc":
  "Village Child Protection Committee",

"otherCommittees.bmc":
  "Biodiversity Management Committee",

"nav.declarations":
  "Declarations",
   // ======================================
// CITIZEN PORTAL DROPDOWN
// ======================================

"birth":
  "Birth Certificate",

"death":
  "Death Certificate",

"residence":
  "Residence Certificate",

"marriage":
  "Marriage Certificate",

"buildingPermit":
  "Building Permit",

"businessTrade":
  "Business Trade License",

"property":
  "Property Card",

  // Hero
  'hero.badge': '🏛️ Gram Panchayat Redgaon Kh',
  'hero.welcome': 'Welcome',
  'hero.title': 'Gram Panchayat Redgaon Kh',
  'hero.desc': 'Your trusted source for village governance services and citizen empowerment.',
  'hero.citizenLogin': 'Citizen Portal',
  'hero.moreKnow': 'Learn More',
  'hero.ministers': 'Honourable Ministers & Officials',
  'hero.gpOfficials': 'Gram Panchayat Officials',

  'hero.minister1.name': 'Chief Minister Devendra Fadnavis',
  'hero.minister1.role': 'Chief Minister, Maharashtra',
  'hero.minister1.desc': 'Leading rural development and infrastructure growth',
  'hero.minister2.name': 'Deputy Chief Minister Eknath Shinde',
  'hero.minister2.role': 'Deputy Chief Minister, Maharashtra',
  'hero.minister2.desc': 'Gram Panchayat empowerment and digital citizen services',
  'hero.minister3.name': 'Deputy Chief Minister Sunetra Ajit Pawar',
  'hero.minister3.role': 'Deputy Chief Minister',
  'hero.minister3.desc': 'Rural roads, water supply and revenue reforms',
  'hero.minister4.name': 'Omkar Pawar',
  'hero.minister4.role': 'Chief Executive Officer, Zilla Parishad',
  'hero.minister4.desc': 'Gram Panchayat strengthening and 73rd amendment implementation',
   'hero.minister5.name': 'Shri. Jayakumar Gore',
  'hero.minister5.role': "Ho'nble Minister, Rural Development and Panchayat Raj",
  'hero.minister5.desc': 'Gram Panchayat strengthening and 73rd amendment implementation',
   'hero.minister6.name': 'Shri. Yogesh Kadam',
  'hero.minister6.role': "Hon'ble Minister of State, Rural Development and Panchayat Raj",
  'hero.minister6.desc': 'Gram Panchayat strengthening and 73rd amendment implementation',
   'hero.minister7.name': 'Dr. Chandrakant Pulkundwar',
  'hero.minister7.role': 'Secretary, Rural Development and Panchayat Raj,',
  'hero.minister7.desc': 'Gram Panchayat strengthening and 73rd amendment implementation',
  

  'hero.official1.name': 'Shri Yadav Kashinath Garud',
  'hero.official1.role': 'Sarpanch',
  'hero.official1.desc': 'Head of Gram Panchayat and development leadership',
  'hero.official2.name': 'Mrs. Sunita Annasaheb Kale',
  'hero.official2.role': 'Deputy Sarpanch',
  'hero.official2.desc': 'Women & child development schemes and Gram Sabha organization',
  'hero.official3.name': 'Mr. Sachin Trambak Sanap',
  'hero.official3.role': 'Gram Panchayat Officer',
  'hero.official3.desc': 'Citizen services, certificates and development schemes coordination',


  // Admin Committee
  'admin.hero.badge': 'Gram Panchayat Redgaon Kh',
  'admin.hero.title': 'Admin Committee',
  'admin.hero.subtitle': 'Gram Panchayat Executive Leadership & Administration',

  'admin.stats.total': 'Total Members',
  'admin.stats.senior': 'Senior Leadership',
  'admin.stats.elected': 'Elected Members',

  'admin.filter.all': 'All',
  'admin.filter.senior': 'Senior',
  'admin.filter.officer': 'Officer',
  'admin.filter.member': 'Members',
  'admin.filter.staff': 'Staff',

  'admin.tier.senior': 'Senior Leadership',
  'admin.tier.officer': 'Administrative Officers',
  'admin.tier.member': 'Committee Members',
  'admin.tier.staff': 'Support Staff',

  // ===============================
// Admin Committee
// ===============================

"admin.hero.badge":
  "Gram Panchayat Redgaon Kh",

"admin.hero.title":
  "Admin Committee",

"admin.hero.subtitle":
  "Gram Panchayat Executive Leadership & Administration",

// ===============================
// Stats
// ===============================

"admin.stats.total":
  "Total Members",

"admin.stats.senior":
  "Senior Leadership",

"admin.stats.elected":
  "Elected Members",

// ===============================
// Filters
// ===============================

"admin.filter.all":
  "All",

"admin.filter.senior":
  "Senior",

"admin.filter.officer":
  "Officer",

"admin.filter.member":
  "Members",

"admin.filter.staff":
  "Staff",

// ===============================
// Tiers
// ===============================

"admin.tier.senior":
  "Senior Leadership",

"admin.tier.officer":
  "Administrative Officers",

"admin.tier.member":
  "Committee Members",

"admin.tier.staff":
  "Support Staff",


  'admin.members': [
    { name: 'Mr. Yadav Kashinath Garud', role: 'Publicly Appointed Sarpanch' },
    { name: 'Mrs. Sunita Annasaheb Kale', role: 'Deputy Sarpanch' },
    { name: 'Mr. Raja Rajaram Dhongde', role: 'Member' },
    { name: 'Mr. Vaibhav Pandurang Yadav', role: 'Member' },
    { name: 'Mr. Patangrao Shivaji Yadav', role: 'Member' },
    { name: 'Mr. Deepak Ramchandra Pardeshi', role: 'Member' },
    { name: 'Mr. Vikas Rajaram Karkate', role: 'Member' },
    { name: 'Mrs. Vaishali Prithviraj Yadav', role: 'Member' },
    { name: 'Mrs. Bharti Dhananjay Yadav', role: 'Member' },
    { name: 'Mrs. Lata Vikas Yadav', role: 'Member' },
    { name: 'Mrs. Anuja Manoj Yadav', role: 'Member' },
    { name: 'Mrs. Sunita Madhukar Pingle', role: 'Member' },
    { name: 'Mrs. Meenakshi Santosh Koli', role: 'Member' },
    { name: 'Mrs. Usha Yashwant Waghmare', role: 'Member' },
  ],


  // Footer / navbar meta
  'navbar.phone': '',
  'navbar.email': '✉️ chdredgaon@gmail.com',
  'navbar.adminLogin': 'Admin Login',
  'navbar.digitalPortal': 'Digital Services Portal',
  'navbar.marathi': '🌐 English',


  'lang.mr': 'Marathi',
  'lang.en': 'English',
  'switch.to': 'Switch to',

  'footer.title': 'For your development, for your service – Gram Panchayat Redgaon Kh',

  'footer.subtitle': 'The official Gram Panchayat Redgaon Kh website – information, schemes and digital services for citizens.',

  'footer.subtitle':
    'The official Gram Panchayat Redgaon Kh website – information, schemes and digital services for citizens.',

  'footer.ctaTitle': 'Get help and information fast',
  'footer.ctaText': 'Contact us today for certificates, grievances or scheme support.',
  'footer.ctaButton': '✉️ Email Us',
  'footer.contact': 'Contact',
  'footer.quickLinks': 'Quick Links',
  'footer.officeHours': 'Office Hours',
  'footer.copy': '© 2025 grampanchayathRedgaon Kh.com | Powered by Gram Panchayat Redgaon Kh',
  'footer.bottom.location': 'Maharashtra, India',

  'footer.officeHours.weekdays': 'Mon–Sat: 10:00 – 5:00',
  'footer.officeHours.saturday': 'Saturday: 10:00 – 2:00',
  'footer.officeHours.sunday': 'Sunday: Closed',
  'footer.address': 'Gram Panchayat Redgaon Kh, Tal., Dist. Nashik – 422306',

  // ======================================
// POPULATION
// ======================================

"population.badge": "Village Statistics",
"population.title": "Population & Village Information",
"population.subtitle":
  "Overview of families, population categories, sanitation facilities, education, and village infrastructure.",

"population.totalFamilies": "Total Families",
"population.scFemale": "SC Female",
"population.scMale": "SC Male",
"population.scTotal": "SC Total",

"population.stFemale": "ST Female",
"population.stMale": "ST Male",
"population.stTotal": "ST Total",

"population.otherFemale": "Other Female",
"population.otherMale": "Other Male",
"population.otherTotal": "Other Total",

"population.bpl": "BPL Families",
"population.apl": "APL Families",

"population.privateToilet": "Private Toilets",
"population.publicToilet": "Public Toilets",

"population.primarySchool": "Primary School",
"population.anganwadi": "Anganwadi Centers",
"population.society": "Society",

"population.area": "Village Area (Hectare)",
"population.farmers": "Farmers",

// ======================================
// INTRODUCTION SECTION
// ======================================

"intro.badge":
  "Village Introduction",

"intro.heading":
  "Welcome to Redgaon Kh",

"intro.desc1":
  "Redgaon Kh in Chandwad Taluka of Nashik district is a historically and culturally important village. Blessed with the memories of Lord Ram and Chhatrapati Shivaji Maharaj, this village is located around 15 km from Chandwad in the drought-prone eastern region.",

"intro.desc2":
  "Agriculture is the primary occupation of the villagers and farming mainly depends on rainfall. Due to low rainfall and seasonal farming, many families face economic challenges.",

"intro.desc3":
  "The village has limited healthcare, education, and employment facilities. Despite this, the citizens of Redgaon Kh are collectively working toward development and a brighter future.",

"intro.button":
  "Learn More",
  // ======================================
// TEMPLE SECTION
// ======================================

"temple.badge":
  "Temples",

"temple.heading":
  "Famous Temples",

"temple.subheading":
  "Experience the spiritual and cultural temples of Redgaon Kh.",

"temple.location":
  "Redgaon Kh",

"temple.hanuman.name":
  "Gramdaivat Hanuman Temple",

"temple.yadavswami.name":
  "Shri Sant Yadav Swami Maharaj Temple",

"temple.khanderao.name":
  "Kuldaiwat Shri Khanderao Temple",

  // ======================================
// ONLINE SERVICES
// ======================================

"services.title":
  "Online Services",

"services.desc":
  "All certificates and services in one place - online application, tracking and download.",

"services.birth.title":
  "Birth Certificate",

"services.birth.desc":
  "Birth registration and certificate download",

"services.death.title":
  "Death Certificate",

"services.death.desc":
  "Death registration services",

"services.residence.title":
  "Residence Certificate",

"services.residence.desc":
  "Residence / address proof certificate",

"services.grievance.title":
  "Grievance Registration",

"services.grievance.desc":
  "Register complaints with Gram Panchayat",

"services.payment.title":
  "Payment Portal",

"services.payment.desc":
  "Online payment facility",

"services.onlineAvailable":
  "Available Online →",

  // ======================================
// CONTACT
// ======================================

"contact.title":
  "Have Something to Say?",

"contact.subtitle":
  "Get in touch with us for suggestions and grievances.",

"contact.tagline":
  "Contact Us",

"contact.sendMessage":
  "Send Message",

"contact.responseTime":
  "We will respond within 1–2 working days.",

"contact.firstName":
  "First Name",

"contact.lastName":
  "Last Name",

"contact.emailAddress":
  "Email Address",

"contact.emailPlaceholder":
  "Your email",

"contact.subject":
  "Subject",

"contact.message":
  "Message",

"contact.placeholderMessage":
  "Write your message here",

"contact.subjectPlaceholder":
  "Select Subject",

"contact.submit":
  "Send Message",

"contact.successTitle":
  "Message Sent Successfully!",

"contact.successMessage":
  "Your message has been sent successfully. We will contact you soon.",

"contact.phoneLabel":
  "Phone",

"contact.emailLabel":
  "Email",

"contact.addressLabel":
  "Address",

"contact.hoursLabel":
  "Office Hours",

"contact.option.birth":
  "Birth Certificate",

"contact.option.death":
  "Death Certificate",

"contact.option.residence":
  "Residence Certificate",

"contact.option.grievance":
  "Grievance",

"contact.option.scheme":
  "Government Scheme",

"contact.option.other":
  "Other",

// "contact.info.phone":
//   "📞 (02346) 243535",

"contact.info.email":
  "✉️ chdredgaon@gmail.com",

"contact.info.address":
  "Tal. Chandwad, Dist. Nashik – 422306",

"contact.info.hours":
  "Mon–Sat, 10:00 AM to 5:00 PM",

"contact.info.title":
  "Contact Information",

"contact.info.desc":
  "Visit the office or contact us through the information below.",

  // ======================================
// CITIZEN PORTAL
// ======================================

"citizenPortal.hero.badge":
  "Digital Citizen Services",

"citizenPortal.hero.title":
  "Citizen Service Portal",

"citizenPortal.hero.desc":
  "Access government schemes, certificates, and online services in one place.",

// Tabs
"citizenPortal.tabs.csc":
  "CSC Services",

// Table Columns
"citizenPortal.table.cols.no":
  "No.",

"citizenPortal.table.cols.scheme":
  "Scheme",

"citizenPortal.table.cols.dept":
  "Department",

"citizenPortal.table.cols.service":
  "Service",

"citizenPortal.table.cols.portal":
  "Portal",

"citizenPortal.table.cols.website":
  "Website",

// QR Section
"citizenPortal.qr.houseTax":
  "House Tax",

"citizenPortal.qr.waterTax":
  "Water Tax",

"citizenPortal.qr.note":
  "Click the QR code to view larger.",

"citizenPortal.qr.popup":
  "Scan QR Code",
  // ======================================
// SMART VILLAGE
// ======================================

"smartvillage.badge":
  "🏡 Gram Panchayat Portal",

"smartvillage.hero.title":
  "Smart Village",

"smartvillage.hero.subtitle":
  "Redgaon Kh",

"smartvillage.hero.desc":
  "A digitally empowered village with e-services, transparency, citizen participation, and sustainable development.",

"smartvillage.btn.learnMore":
  "Learn More",

// Stats
"smartvillage.stats.pillars":
  "5 Core Pillars",

"smartvillage.stats.digital":
  "Digital Services",

"smartvillage.stats.participation":
  "Citizen Participation",

"smartvillage.stats.village":
  "Smart Gram Panchayat",

// Section
"smartvillage.section.eyebrow":
  "Digital Village Initiative",

"smartvillage.section.title":
  "Our Smart Journey",

"smartvillage.section.desc":
  "Digital Gram Panchayat principles and 5 foundational pillars.",

// Pillars
"smartvillage.pillar.water.title":
  "Water & Health",

"smartvillage.pillar.water.desc":
  "Ensuring clean and safe water supply, implementing sanitation initiatives, and promoting awareness for a healthy lifestyle.",

"smartvillage.pillar.admin.title":
  "Administrative Management",

"smartvillage.pillar.admin.desc":
  "Transparent, efficient, and responsible governance with sustainable planning, resource management, and citizen participation.",

"smartvillage.pillar.energy.title":
  "Energy Management",

"smartvillage.pillar.energy.desc":
  "Ensuring reliable electricity supply, promoting renewable energy like solar power, and building an eco-friendly community.",

"smartvillage.pillar.education.title":
  "Education & Skill Development",

"smartvillage.pillar.education.desc":
  "Providing quality education, improving literacy, and empowering youth and women through vocational and digital learning programs.",

"smartvillage.pillar.accountability.title":
  "Accountability & Transparency",

"smartvillage.pillar.accountability.desc":
  "Making decisions, funds, and development activities transparent through public participation and regular reporting.",

"smartvillage.pillar.btn":
  "Learn More →",

"smartvillage.meta":
  "Gram Panchayat Redgaon Kh",

  // ======================================
// RTI SECTION
// ======================================

"rti.title":
  "Right to Information",

"rti.subtitle":
  "Public Information Portal",

"rti.heroText":
  "View Gram Panchayat public documents, certificates, and information transparently.",

// Table Headers
"rti.table.colSr":
  "Sr. No.",

"rti.table.colDoc":
  "Document",

"rti.table.colPeriod":
  "Period",

"rti.table.colReceived":
  "Received",

"rti.table.colApproved":
  "Approved",

"rti.table.colRejected":
  "Rejected",

"rti.table.colReason":
  "Reason",

// Stats
"rti.stats.totalReceived":
  "Total Received",

"rti.stats.totalApproved":
  "Total Approved",

"rti.stats.totalRejected":
  "Total Rejected",

// Documents
"rti.documents.title":
  "RTI Documents & Certificates",

"rti.search.placeholder":
  "Search documents...",

"rti.noResults":
  "No records found",

// Toolbar
"rti.downloadCSV":
  "Download CSV",

"rti.print":
  "Print",

// Extra
"rti.records":
  "records",

"rti.received":
  "Received",

"rti.approved":
  "Approved",

"rti.rejected":
  "Rejected",

"rti.badge":
  "Right to Information",

  // ======================================
// GRIEVANCE SECTION
// ======================================

"grievance.hero.badge":
  "Citizen Grievance Portal",

"grievance.hero.title":
  "Register Your Grievance",

"grievance.hero.sub":
  "Submit complaints related to village services and administration online.",

// Toast
"grievance.toast.success":
  "Complaint submitted successfully!",

"grievance.toast.error":
  "Failed to submit complaint. Please try again.",

// Form
"grievance.form.title":
  "Complaint Registration Form",

"grievance.form.fullName.label":
  "Full Name",

"grievance.form.fullName.placeholder":
  "Enter your full name",

"grievance.form.mobile.label":
  "Mobile Number",

"grievance.form.mobile.placeholder":
  "Enter 10-digit mobile number",

"grievance.form.aadhaar.label":
  "Aadhaar Number",

"grievance.form.aadhaar.placeholder":
  "Enter 12-digit Aadhaar number",

"grievance.form.email.optionalLabel":
  "Email (Optional)",

"grievance.form.email.placeholder":
  "Enter email address",

"grievance.form.department.label":
  "Select Department",

"grievance.form.details.label":
  "Complaint Details",

"grievance.form.details.placeholder":
  "Describe your grievance here...",

"grievance.form.submit":
  "Submit Complaint",

"grievance.form.submitting":
  "Submitting...",


// Validation Errors

// ===============================
// Validation Errors
// ===============================


"grievance.form.error.fullName.required":
  "Full name is required",

"grievance.form.error.mobile.required":

  "Enter valid 10-digit mobile number",

"grievance.form.error.aadhaar.required":
  "Enter valid 12-digit Aadhaar number",



"grievance.form.error.aadhaar.required":
  "Valid Aadhaar number is required",


"grievance.form.error.department.required":
  "Please select a department",

"grievance.form.error.details.required":
  "Complaint details are required",


// Departments

// ===============================
// Departments
// ===============================


"grievance.form.department.waterSupply":
  "Water Supply",

"grievance.form.department.roadInfra":
  "Road & Infrastructure",

"grievance.form.department.health":
  "Health Department",

"grievance.form.department.education":
  "Education",

"grievance.form.department.agriculture":
  "Agriculture",

"grievance.form.department.revenue":
  "Revenue",

"grievance.form.department.sanitation":
  "Sanitation",

"grievance.form.department.electricity":
  "Electricity",


// Sidebar

// ===============================
// Toast
// ===============================

"grievance.toast.success":
  "Complaint submitted successfully",

"grievance.toast.error":
  "Something went wrong",

// ===============================
// Sidebar
// ===============================


"grievance.sidebar.officeContact.title":
  "Office Contact",

"grievance.sidebar.officeHours.title":
  "Office Hours",

"grievance.sidebar.officeHours.mondayToFriday":
  "Monday - Friday",

"grievance.sidebar.officeHours.mondayToFriday.time":

  "10:00 AM - 5:00 PM",

 


"grievance.sidebar.officeHours.saturday":
  "Saturday",

"grievance.sidebar.officeHours.saturday.time":

  "10:00 AM - 2:00 PM",

 

"grievance.sidebar.officeHours.sunday":
  "Sunday",

"grievance.sidebar.officeHours.sunday.value":
  "Closed",

"grievance.sidebar.status.title":
  "Complaint Status",

"grievance.sidebar.status.pending":
  "Pending Complaints",

"grievance.sidebar.status.pending.value":

  "Under Review",

"grievance.sidebar.status.followup":
  "Follow-up Support",

"grievance.sidebar.status.followup.value":
  "Available",

// Contact Labels
"grievance.contact.address":
  "Address",

"grievance.contact.phone":
  "Phone",

"grievance.contact.email":
  "Email",

"grievance.contact.call":
  "Call",

"grievance.contact.emailBtn":
  "Email",

  // ======================================
// ACTIVITY SECTION
// ======================================

"activity.hero.badge":
  "Village Activities",

"activity.hero.title":
  "Development Activities",

"activity.hero.sub":
  "Social, environmental, and development initiatives carried out in Redgaon Kh.",

// Activity 1
"activity.1.tag":
  "Water Conservation",

"activity.1.title":
  "Water Foundation / Water Cup Campaign",

"activity.1.desc":
  "Village-wide water conservation and watershed management through community participation.",

// Activity 2
"activity.2.tag":
  "Agriculture",

"activity.2.title":
  "Modern Farming Practices",

"activity.2.desc":
  "Awareness and implementation of sustainable farming and irrigation methods.",

// Activity 3
"activity.3.tag":
  "Education",

"activity.3.title":
  "Educational Development",

"activity.3.desc":
  "Improving school facilities and encouraging digital learning among students.",

// Activity 4
"activity.4.tag":
  "Health",

"activity.4.title":
  "Health & Sanitation Campaign",

"activity.4.desc":
  "Village cleanliness drives and public health awareness programs.",

// Activity 5
"activity.5.tag":
  "Women Empowerment",

"activity.5.title":
  "Self Help Groups",

"activity.5.desc":
  "Encouraging women participation through savings groups and skill development.",

// Activity 6
"activity.6.tag":
  "Environment",

"activity.6.title":
  "Tree Plantation",

"activity.6.desc":
  "Tree plantation initiatives for environmental conservation and greenery.",

// Activity 7
"activity.7.tag":
  "Digital Village",

"activity.7.title":
  "Digital Services Awareness",

"activity.7.desc":
  "Promoting online citizen services and digital literacy in the village.",

// Water Cup Table
"activity.watercup.title":
  "Water Foundation / Water Cup 2017 (Community Work) — 40 Nights / 40 Days",

"activity.watercup.col.work":
  "Work Name",

"activity.watercup.col.progress":
  "Measurement / Achievement",

// Table Data
"activity.watercup.nursery":
  "Nursery",

"activity.watercup.soil":
  "Soil Testing",

"activity.watercup.drainage":
  "Drainage Pits",

"activity.watercup.labour":
  "Labour",

"activity.watercup.machine":
  "Work Done by Machine",

"activity.watercup.area":
  "Area Treatment",

"activity.watercup.waterSaving":
  "Water Saving Technology",

"activity.watercup.protection":
  "Protection of Structures",

"activity.watercup.well":
  "Well Refilling",

  // ======================================
// ABOUT US
// ======================================

"about.hero.badge":
  "About Village",

"about.hero.title":
  "About Redgaon Kh",

"about.hero.sub":
  "History, culture, development and vision of the village.",

// Population
"about.population.title":
  "Village Population",

"about.population.total":
  "Total Population",

"about.population.male":
  "Male",

"about.population.female":
  "Female",

"about.population.families":
  "Families",

// Village Intro
"about.village.title":
  "Village Introduction",

"about.village.introduction.title":
  "Introduction",

"about.village.introduction.desc1":
  "Redgaon Kh is a culturally rich village in Chandwad Taluka of Nashik district.",

"about.village.introduction.desc2":
  "Agriculture is the main occupation of the villagers and farming depends mostly on rainfall.",

"about.village.introduction.desc3":
  "The village has made progress in education, sanitation, and digital services.",

"about.village.introduction.desc4":
  "Citizens actively participate in village development and social activities.",

"about.village.introduction.desc5":
  "Water conservation and environmental awareness are major priorities.",

"about.village.introduction.desc6":
  "The Gram Panchayat continuously works for sustainable development.",

// Saint Section
"about.village.saint.title":
  "Saint Tradition",

"about.village.saint.desc1":
  "The village has a rich spiritual and cultural heritage.",

"about.village.saint.desc2":
  "Local temples and saints inspire social unity and harmony.",

"about.village.saint.desc3":
  "Religious festivals are celebrated with devotion and participation.",

"about.village.saint.desc4":
  "Traditional values continue to guide village life.",

"about.village.saint.desc5":
  "The village preserves its historical and spiritual identity.",

// Culture
"about.village.culture.title":
  "Culture & Traditions",

"about.village.culture.desc1":
  "Village festivals and traditions strengthen community bonding.",

"about.village.culture.desc2":
  "Folk arts and cultural events are celebrated enthusiastically.",

"about.village.culture.desc3":
  "The younger generation actively participates in cultural preservation.",

// Development
"about.vikas.title":
  "Development Works",

"about.vikas.table.sr":
  "Sr. No.",

"about.vikas.table.work":
  "Development Work",

"about.vikas.table.year":
  "Year",

"about.vikas.table.amount":
  "Fund",

"about.vikas.table.status":
  "Status",

"about.vikas.work.road":
  "Road Development Work",

"about.vikas.work.water":
  "Water Supply Scheme",

"about.vikas.work.anganwadi":
  "Anganwadi Renovation",

"about.vikas.status.completed":
  "Completed",

"about.vikas.status.progress":
  "In Progress",

// Ideal Village
"about.adarsh.title":
  "Ideal Village Components",

"about.adarsh.cleanliness":
  "Cleanliness",

"about.adarsh.cleanliness.desc":
  "Maintaining village cleanliness and sanitation awareness.",

"about.adarsh.water":
  "Water Conservation",

"about.adarsh.water.desc":
  "Efficient use and conservation of water resources.",

"about.adarsh.education":
  "Education",

"about.adarsh.education.desc":
  "Improving educational quality and literacy.",

"about.adarsh.health":
  "Health",

"about.adarsh.health.desc":
  "Providing health awareness and better facilities.",

"about.adarsh.environment":
  "Environment",

"about.adarsh.environment.desc":
  "Promoting greenery and environmental conservation.",

  // ======================================
// DIGITAL LIBRARY
// ======================================

"digitalLibrary.hero.title":
  "Digital Library",

"digitalLibrary.hero.subtitle":
  "Educational resources, books, videos, newspapers and study materials for UPSC & MPSC preparation.",

// Videos
"digitalLibrary.videos.title":
  "Educational Videos",

"digitalLibrary.video1.title":
  "UPSC Preparation Guidance",

"digitalLibrary.video2.title":
  "MPSC Study Strategy",

// YouTube
"digitalLibrary.youtube.title":
  "Popular YouTube Channels",

// Newspapers
"digitalLibrary.newspapers.title":
  "Daily Newspapers",

// Books
"digitalLibrary.upscBooks.title":
  "UPSC Study Books",

"digitalLibrary.mpscBooks.title":
  "MPSC Study Books",

// Buttons
"digitalLibrary.openPdf":
  "Open PDF",

  // ======================================
// BIRTH CERTIFICATE



"grievance.sidebar.status.followup":
  "Follow-up Cases",

"grievance.sidebar.status.followup.value":
  "5",
 
  // ===============================
// ===============================
// Population
// ===============================

"population.badge":
  "Village Statistics",

"population.title":
  "Gram Panchayat Statistical Information",

"population.subtitle":
  "Population and Facility Information of Gram Panchayat",

"population.totalFamilies":
  "Total Families",

"population.scFemale":
  "SC Female",

"population.scMale":
  "SC Male",

"population.scTotal":
  "SC Total",

"population.stFemale":
  "ST Female",

"population.stMale":
  "ST Male",

"population.stTotal":
  "ST Total",

"population.otherFemale":
  "Other Female",

"population.otherMale":
  "Other Male",

"population.otherTotal":
  "Other Total",

"population.bpl":
  "BPL Families",

"population.apl":
  "APL Families",

"population.privateToilet":
  "Private Toilets",

"population.publicToilet":
  "Public Toilets",

"population.primarySchool":
  "Primary Schools",

"population.anganwadi":
  "Anganwadi Centers",

"population.society":
  "Co-operative Society",

"population.area":
  "Geographical Area (Hectare)",

"population.farmers":
  "Farmer Account Holders",
  // ===============================
// Temple Section
// ===============================

"temple.heading":
  "Famous Temples",

"temple.subheading":
  "Explore the spiritual and cultural temples of Redgaon Kh.",

"temple.location":
  "Redgaon Kh",

"temple.button":
  "View More",

"temple.hanuman.name":
  "Gram Daivat Hanuman Temple",

"temple.yadavswami.name":
  "Shri Sant Yadav Swami Maharaj Temple",

"temple.khanderao.name":
  "Kuldaiwat Shri Khanderao Temple",

  // ===============================
// Introduction Section
// ===============================

"intro.badge":
  "Village Introduction",

"intro.heading":
  "Welcome to Redgaon Kh",

"intro.desc1":
  "Redgaon Kh village in Chandwad Taluka of Nashik district is a historic and culturally important village blessed by the memories of Lord Ramchandra and Chhatrapati Shivaji Maharaj. Located around 15 km from Chandwad, the village lies in the drought-prone eastern region of the taluka.",

"intro.desc2":
  "Agriculture is the primary occupation of the villagers, and farming mainly depends on natural rainfall due to limited water resources. Because of low rainfall and seasonal farming, economic conditions remain challenging for many families.",

"intro.desc3":
  "The village also faces challenges in healthcare, education, and employment opportunities. Despite these difficulties, the people of Redgaon Kh continue to work together towards development and a better future.",

"intro.button":
  "Explore More",
  // QR Section
"citizenPortal.qr.houseTax":
  "House Tax",

"citizenPortal.qr.waterTax":
  "Water Tax",

"citizenPortal.qr.note":
  "Click QR code to enlarge.",

"citizenPortal.qr.popup":
  "Scan QR Code",

  // ======================================
// Birth Certificate

// ======================================

"birth.title":
  "Birth Certificate",


"birth.card.desc":
  "Apply online for birth certificate services provided by Gram Panchayat.",

"birth.backHome":
  "Back to Home",

// Details
"birth.details.title":
  "Birth Certificate Details",

"birth.fee":
  "Application Fee: ₹20",

// Documents

"birth.backHome":
  "Back To Home",

"birth.card.title":
  "Get Birth Certificate from Gram Panchayat Portal",

"birth.card.desc":
  "Click below to apply for a birth certificate. After submitting the application you will receive a token number. Keep it safe.",

"birth.details.title":
  "Birth Certificate",

"birth.fee":
  "Fee: ₹20",


"birth.documents":
  "Required Documents",

"birth.doc1":
 
  "Hospital birth proof / discharge card",

"birth.doc2":
  "Parents Aadhaar Card copy",

"birth.doc3":
  "Address proof document",

// Process
"birth.process":
  "Application Process",

"birth.step1":
  "Fill out the online application form",

"birth.step2":
  "Upload required documents",

"birth.step3":
  "Submit application and verify details",

"birth.step4":
  "Download certificate after approval",

// Timeline
"birth.timeline":
  "Processing Time",

"birth.timelineValue":
  "Certificate will be issued within 3–7 working days.",

// Apply

  

"birth.doc2":
  "Parents Aadhaar Card",

"birth.doc3":
  "Hospital Certificate",

"birth.process":
  "Process",

"birth.step1":
  "Apply Online",

"birth.step2":
  "Upload Documents",

"birth.step3":
  "Pay Fee",

"birth.step4":
  "Download Certificate",

"birth.timeline":
  "Timeline",

"birth.timelineValue":
  "2–3 Days",


"birth.ready":
  "Ready to Apply?",

"birth.apply":
  "Apply Now",


"birth.applyDesc":
  "Apply online quickly and easily through Gram Panchayat services.",

  // ======================================
// BIRTH CERTIFICATE FORM
// ======================================

// Top
"birthForm.top.title":
  "Birth Certificate Application",

"birthForm.top.subtitle":
  "Gram Panchayat Digital Service",

"birthForm.fee":
  "Application Fee",

// Steps
"birthForm.step1.mr":
  "मोबाईल पडताळणी",

"birthForm.step1.en":
  "Mobile Verification",

"birthForm.step2.mr":
  "बालक माहिती",

"birthForm.step2.en":
  "Child Details",

"birthForm.step3.mr":
  "पालक माहिती",

"birthForm.step3.en":
  "Parent Details",

"birthForm.step4.mr":
  "कागदपत्रे",

"birthForm.step4.en":
  "Documents",

"birthForm.step5.mr":
  "पेमेंट",

"birthForm.step5.en":
  "Payment",

// Mobile
"birthForm.mobile.title":
  "Mobile Verification",

"birthForm.mobile.subtitle":
  "Verify your mobile number using OTP",

"birthForm.mobileNumber":
  "Mobile Number",

"birthForm.mobilePlaceholder":
  "Enter mobile number",

"birthForm.otp":
  "OTP",

"birthForm.otpPlaceholder":
  "Enter OTP",

"birthForm.verify":
  "Verify OTP",

// Child
"birthForm.child.title":
  "Child Information",

"birthForm.child.subtitle":
  "Enter birth details of the child",

"birthForm.childName":
  "Child Name",

"birthForm.dob":
  "Date of Birth",

"birthForm.gender":
  "Gender",

"birthForm.genderMale":
  "Male",

"birthForm.genderFemale":
  "Female",

"birthForm.birthPlace":
  "Birth Place",

// Parent
"birthForm.parent.title":
  "Parent Information",

"birthForm.parent.subtitle":
  "Enter parent details",

"birthForm.fatherName":
  "Father Name",

"birthForm.motherName":
  "Mother Name",

"birthForm.address":
  "Address",

// Documents
"birthForm.documents.title":
  "Upload Documents",

"birthForm.documents.subtitle":
  "Upload required documents for verification",

// Payment
"birthForm.payment.title":
  "Payment",

"birthForm.payment.subtitle":
  "Complete the application fee payment",

"birthForm.applicationFee":
  "Birth certificate application fee",

"birthForm.pay":
  "Pay Now",

// Common Buttons
"birthForm.next":
  "Next",

"birthForm.back":
  "Back",

// Success
"birthForm.success.title":
  "Application Submitted Successfully",

"birthForm.success.subtitle":
  "Your birth certificate application has been submitted successfully.",

"birthForm.token":
  "Application Token",

"birthForm.home":
  "Back to Home",

  // ======================================
// BUILDING PERMIT CERTIFICATE
// ======================================

"permit.badge":
  "Building Permit",

"permit.title":
  "Building Permit Certificate",

"permit.subtitle":
  "Apply online for building construction permission from Gram Panchayat.",

"permit.back":
  "Back to Home",

// Details
"permit.details":
  "Building Permit Details",

"permit.fee":
  "Application Fee: ₹100",

// Documents
"permit.documents":
  "Required Documents",

"permit.doc1":
  "Land ownership proof",

"permit.doc2":
  "Building layout / map",

"permit.doc3":
  "Applicant Aadhaar Card copy",

"permit.doc4":
  "Property tax receipt",

// Process
"permit.process":
  "Application Process",

"permit.step1":
  "Fill out the online building permit application",

"permit.step2":
  "Upload all required documents",

"permit.step3":
  "Application verification by Gram Panchayat",

"permit.step4":
  "Site inspection by authority",

"permit.step5":
  "Permit approval and certificate issue",

// Timeline
"permit.timeline":
  "Processing Time",

"permit.timelineValue":
  "Building permit will be issued within 7–15 working days.",

// Apply
"permit.applyTitle":
  "Ready to Apply?",

"permit.applyDesc":
  "Submit your building permit request online quickly and securely.",

"permit.apply":
  "Apply Now",

  // ======================================
// BUILDING PERMIT FORM
// ======================================

"permitForm.title":
  "Building Permit Form",

"permitForm.subtitle":
  "Apply for Building Permit Certificate Online",

// Buttons
"permitForm.next":
  "Next",

"permitForm.back":
  "Back",

"permitForm.submit":
  "Submit Application",

"permitForm.home":
  "Back To Home",

// Step 1
"permitForm.applicantName":
  "Applicant Name",

"permitForm.mobile":
  "Mobile Number",

// Step 2
"permitForm.aadhar":
  "Aadhar Number",

"permitForm.survey":
  "Survey Number",

// Step 3
"permitForm.plot":
  "Plot Number",

"permitForm.buildingType":
  "Building Type",

"permitForm.select":
  "Select",

"permitForm.residential":
  "Residential",

"permitForm.commercial":
  "Commercial",

// Step 4
"permitForm.area":
  "Area (Sq.ft)",

"permitForm.address":
  "Building Address",

// Step 5
"permitForm.upload":
  "Upload Documents",

// Success
"permitForm.success":
  "Application Submitted Successfully",

"permitForm.token":
  "Token Number",

  // ======================================
// BUSINESS TRADE LICENSE
// ======================================

"trade.title":
  "Business & Trade License",

"trade.subtitle":
  "Apply for Business and Trade License online.",

// Details
"trade.details":
  "License Details",

"trade.fee":
  "Application Fee : ₹300",

// Documents
"trade.documents":
  "Required Documents",

"trade.doc1":
  "Aadhaar Card",

"trade.doc2":
  "Shop Address Proof",

"trade.doc3":
  "PAN Card",

"trade.doc4":
  "Business Registration",

// Process
"trade.process":
  "Application Process",

"trade.step1":
  "Complete Application Form",

"trade.step2":
  "Upload Business Documents",

"trade.step3":
  "Verification Process",

"trade.step4":
  "License Approval",

// Timeline
"trade.timeline":
  "Processing Time",

"trade.timelineValue":
  "7 - 10 Working Days",

// Apply
"trade.applyTitle":
  "Apply For Trade License",

"trade.applyDesc":
  "Start your business registration process online.",

"trade.apply":
  "Apply Now",

  // ======================================
// BUSINESS TRADE LICENSE FORM
// ======================================

// Top Bar
"tradeForm.top.title":
  "Business License Application",

"tradeForm.top.subtitle":
  "Business Trade License Application",

"tradeForm.fee":
  "Fee",

// Stepper
"tradeForm.step1.mr":
  "OTP सत्यापन",

"tradeForm.step1.en":
  "Verification",

"tradeForm.step2.mr":
  "व्यवसाय माहिती",

"tradeForm.step2.en":
  "Business Details",

"tradeForm.step3.mr":
  "मालक माहिती",

"tradeForm.step3.en":
  "Owner Details",

"tradeForm.step4.mr":
  "कागदपत्रे",

"tradeForm.step4.en":
  "Documents",

"tradeForm.step5.mr":
  "पेमेंट",

"tradeForm.step5.en":
  "Payment",

// Step 1
"tradeForm.mobileVerification":
  "Mobile Verification",

"tradeForm.mobileNumber":
  "Mobile Number",

"tradeForm.otp":
  "OTP",

"tradeForm.verifyOtp":
  "Verify OTP",

// Step 2
"tradeForm.businessDetails":
  "Business Details",

"tradeForm.businessName":
  "Business Name",

"tradeForm.businessAddress":
  "Business Address",

"tradeForm.businessType":
  "Business Type",

"tradeForm.licenseType":
  "License Type",

"tradeForm.new":
  "New",

"tradeForm.renewal":
  "Renewal",

// Step 3
"tradeForm.ownerDetails":
  "Owner Details",

"tradeForm.ownerName":
  "Owner Name",

"tradeForm.aadhar":
  "Aadhar Number",

"tradeForm.ownerAddress":
  "Owner Address",

// Step 4
"tradeForm.documents":
  "Upload Documents",

// Step 5
"tradeForm.payment":
  "Payment",

"tradeForm.tradeFee":
  "Trade License Fee",

"tradeForm.paySubmit":
  "Pay & Submit",

// Common Buttons
"tradeForm.next":
  "Next",

"tradeForm.back":
  "Back",

"tradeForm.select":
  "-- Select --",

// Success
"tradeForm.successMr":
  "Application Successful!",

"tradeForm.successEn":
  "Business Trade License Submitted Successfully",

"tradeForm.token":
  "Token Number",

"tradeForm.home":
  "Back To Home",

  // ======================================
// DEATH CERTIFICATE
// ======================================

  // ======================================
// Birth Form
// ======================================

"birthForm.step1.title":
  "Mobile Verification",

"birthForm.step1.subtitle":
  "Verification",

"birthForm.step1.desc":
  "Enter your mobile number and verify OTP",

"birthForm.step1.sendOtp":
  "Send OTP",

"birthForm.step1.verify":
  "Verify →",

"birthForm.step2.title":
  "Child Information",

"birthForm.step2.subtitle":
  "Child Details",

"birthForm.step3.title":
  "Parent Information",

"birthForm.step3.subtitle":
  "Parent Details",

"birthForm.step4.title":
  "Upload Documents",

"birthForm.step4.subtitle":
  "Documents",

"birthForm.step5.title":
  "Payment",

"birthForm.step5.subtitle":
  "Payment Gateway",

"birthForm.success.title":
  "Application Submitted!",

"birthForm.success.subtitle":
  "Application Submitted Successfully",

 
// Death Certificate


"death.title":
  "Death Certificate",


"death.card.desc":
  "Apply online for death certificate services provided by Gram Panchayat.",

"death.backHome":
  "Back to Home",

// Details
"death.details.title":
  "Death Certificate Details",

"death.fee":
  "Application Fee: ₹20",

// Documents

"death.backHome":
  "Back To Home",

"death.card.title":
  "Get Death Certificate from Gram Panchayat Portal",

"death.card.desc":
  "Click below to apply for a death certificate. After submitting the application you will receive a token number. Keep it safe.",

"death.details.title":
  "Death Certificate",

"death.fee":
  "Fee: ₹20",


"death.documents":
  "Required Documents",

"death.doc1":

  "Hospital death proof / medical certificate",

"death.doc2":
  "Applicant Aadhaar Card copy",

"death.doc3":
  "Address proof document",

// Process
"death.process":
  "Application Process",

"death.step1":
  "Fill out the online application form",

"death.step2":
  "Upload required documents",

"death.step3":
  "Submit application and verify details",

"death.step4":
  "Download certificate after approval",

// Timeline
"death.timeline":
  "Processing Time",

"death.timelineValue":
  "Certificate will be issued within 3–7 working days.",

// Apply

  

"death.doc2":
  "Applicant Aadhaar Card",

"death.doc3":
  "Hospital Certificate",

"death.process":
  "Process",

"death.step1":
  "Apply Online",

"death.step2":
  "Upload Documents",

"death.step3":
  "Pay Fee",

"death.step4":
  "Download Certificate",

"death.timeline":
  "Timeline",

"death.timelineValue":
  "2–3 Days",


"death.ready":
  "Ready to Apply?",

"death.apply":
  "Apply Now",


"death.applyDesc":
  "Apply online quickly and easily through Gram Panchayat services.",

  // ======================================
// DEATH CERTIFICATE FORM
// ======================================

// Header
"deathForm.header.title":
  "Death Certificate",

"deathForm.header.subtitle":
  "Apply for Death Certificate Online",

// Step 1

 
// Death Form


"deathForm.step1.title":
  "Mobile Verification",

"deathForm.step1.subtitle":

  "Verify your mobile number using OTP",

"deathForm.step1.mobile":
  "Mobile Number",

"deathForm.step1.mobilePlaceholder":
  "Enter mobile number",

"deathForm.step1.otp":
  "OTP",

"deathForm.step1.otpPlaceholder":
  "Enter OTP",

"deathForm.step1.verify":
  "Verify OTP",

// Step 2

 

"deathForm.step1.desc":
  "Enter your mobile number and verify OTP",

"deathForm.step1.sendOtp":
  "Send OTP",

"deathForm.step1.verify":
  "Verify →",


"deathForm.step2.title":
  "Deceased Details",

"deathForm.step2.subtitle":

  "Enter deceased person information",

"deathForm.step2.name":
  "Deceased Name",

"deathForm.step2.date":
  "Date of Death",

"deathForm.step2.gender":
  "Gender",

"deathForm.step2.select":
  "Select",

"deathForm.step2.male":
  "Male",

"deathForm.step2.female":
  "Female",

"deathForm.step2.place":
  "Place of Death",

// Step 3

  

"deathForm.step3.title":
  "Informant Details",

"deathForm.step3.subtitle":

  "Enter applicant / informant details",

"deathForm.step3.name":
  "Informant Name",

"deathForm.step3.relation":
  "Relation",

"deathForm.step3.address":
  "Address",

// Step 4



"deathForm.step4.title":
  "Upload Documents",

"deathForm.step4.subtitle":

  "Upload required documents",

// Step 5



"deathForm.step5.title":
  "Payment",

"deathForm.step5.subtitle":

  "Complete application fee payment",

"deathForm.step5.fee":
  "Application Fee",

"deathForm.step5.submit":
  "Pay & Submit",

// Common Buttons
"deathForm.next":
  "Next",

"deathForm.back":
  "Back",

// Success
"deathForm.success.title":
  "Application Submitted Successfully",

  // ======================================
// MARRIAGE CERTIFICATE
// ======================================

"marriage.title":
  "Marriage Certificate",

"marriage.subtitle":
  "Apply online for Marriage Certificate services provided by Gram Panchayat.",

// Details
"marriage.details":
  "Marriage Certificate Details",

"marriage.fee":
  "Application Fee: ₹100",

// Documents
"marriage.documents":
  "Required Documents",

"marriage.doc1":
  "Bride Aadhaar Card copy",

"marriage.doc2":
  "Groom Aadhaar Card copy",

"marriage.doc3":
  "Marriage Invitation Card / Proof",

"marriage.doc4":
  "Passport Size Photos",

// Process
"marriage.process":
  "Application Process",

"marriage.step1":
  "Fill out the online marriage certificate form",

"marriage.step2":
  "Upload required documents",

"marriage.step3":
  "Verification by Gram Panchayat",

"marriage.step4":
  "Certificate approval and issue",

// Timeline
"marriage.timeline":
  "Processing Time",

"marriage.timelineValue":
  "Certificate will be issued within 5–10 working days.",

// Apply
"marriage.applyTitle":
  "Apply For Marriage Certificate",

"marriage.applyDesc":
  "Start your marriage registration process online quickly and securely.",

"marriage.apply":
  "Apply Now",

  // ======================================
// MARRIAGE CERTIFICATE FORM
// ======================================

"marriageForm.top.title":
  "Marriage Certificate Application",

"marriageForm.top.subtitle":
  "Online Marriage Registration Service",

"marriageForm.fee":
  "Application Fee: ₹50",

// Steps
"marriageForm.step1.mr":
  "Mobile Verification",

"marriageForm.step1.en":
  "Verification",

"marriageForm.step2.mr":
  "Marriage Information",

"marriageForm.step2.en":
  "Marriage Details",

"marriageForm.step3.mr":
  "Bride & Groom Information",

"marriageForm.step3.en":
  "Bride & Groom",

"marriageForm.step4.mr":
  "Documents",

"marriageForm.step4.en":
  "Upload Documents",

"marriageForm.step5.mr":
  "Payment",

"marriageForm.step5.en":
  "Payment",

// Step 1
"marriageForm.mobileVerification":
  "Mobile Verification",

"marriageForm.mobile":
  "Mobile Number",

"marriageForm.mobilePlaceholder":
  "Enter mobile number",

"marriageForm.otp":
  "OTP",

"marriageForm.otpPlaceholder":
  "Enter OTP",

"marriageForm.verifyOtp":
  "Verify OTP",

// Step 2
"marriageForm.marriageDetails":
  "Marriage Details",

"marriageForm.marriageDate":
  "Marriage Date",

"marriageForm.marriagePlace":
  "Marriage Place",

"marriageForm.registrationNumber":
  "Registration Number",

"marriageForm.marriageType":
  "Marriage Type",

"marriageForm.hindu":
  "Hindu Marriage",

"marriageForm.court":
  "Court Marriage",

"marriageForm.other":
  "Other",

// Step 3
"marriageForm.brideGroom":
  "Bride & Groom Details",

"marriageForm.groomName":
  "Groom Name",

"marriageForm.brideName":
  "Bride Name",

"marriageForm.address":
  "Address",

// Step 4
"marriageForm.documents":
  "Upload Documents",

// Step 5
"marriageForm.payment":
  "Payment",

"marriageForm.applicationFee":
  "Application Fee",

"marriageForm.paySubmit":
  "Pay & Submit",

// Common
"marriageForm.next":
  "Next",

"marriageForm.back":
  "Back",

"marriageForm.select":
  "-- Select --",

// Success
"marriageForm.successMr":
  "Application Successful!",

"marriageForm.successEn":
  "Marriage Certificate Application Submitted Successfully",

"marriageForm.token":
  "Token Number",

"marriageForm.home":
  "Back To Home",

  // ======================================
// BUILDING PERMIT FORM
// ======================================

"permitForm.title":
  "Building Permit Application",

"permitForm.subtitle":
  "Apply Online for Building Construction Permission",

// Stepper
"permitForm.step1.mr":
  "Applicant Details",

"permitForm.step1.en":
  "Applicant",

"permitForm.step2.mr":
  "Identity Details",

"permitForm.step2.en":
  "Identity",

"permitForm.step3.mr":
  "Building Details",

"permitForm.step3.en":
  "Building",

"permitForm.step4.mr":
  "Address Details",

"permitForm.step4.en":
  "Address",

"permitForm.step5.mr":
  "Document Upload",

"permitForm.step5.en":
  "Documents",

// Buttons
"permitForm.next":
  "Next",

"permitForm.back":
  "Back",

"permitForm.submit":
  "Submit Application",

"permitForm.home":
  "Back To Home",

// Step 1
"permitForm.applicantName":
  "Applicant Name",

"permitForm.mobile":
  "Mobile Number",

// Step 2
"permitForm.aadhar":
  "Aadhar Number",

"permitForm.survey":
  "Survey Number",

// Step 3
"permitForm.plot":
  "Plot Number",

"permitForm.buildingType":
  "Building Type",

"permitForm.select":
  "-- Select --",

"permitForm.residential":
  "Residential Building",

"permitForm.commercial":
  "Commercial Building",

// Step 4
"permitForm.area":
  "Construction Area (Sq.ft)",

"permitForm.address":
  "Building Address",

// Step 5
"permitForm.upload":
  "Upload Required Documents",

// Success
"permitForm.success":
  "Application Submitted Successfully",

"permitForm.token":
  "Application Token Number",

  // ======================================
// BUILDING PERMIT CERTIFICATE
// ======================================

"permit.badge":
  "Building Permission",

"permit.title":
  "Building Permit Certificate",

"permit.subtitle":
  "Apply online for construction permission and building approval services provided by Gram Panchayat.",

"permit.back":
  "Back To Home",


// DETAILS

"permit.details":
  "Building Permit Details",

"permit.fee":
  "Application Fee : ₹100",


// DOCUMENTS

"permit.documents":
  "Required Documents",

"permit.doc1":
  "Land ownership proof",

"permit.doc2":
  "Building layout / approved map",

"permit.doc3":
  "Applicant Aadhaar Card copy",

"permit.doc4":
  "Property tax receipt",


// PROCESS

"permit.process":
  "Application Process",

"permit.step1":
  "Fill out the online building permit application form",

"permit.step2":
  "Upload all required documents",

"permit.step3":
  "Application verification by Gram Panchayat",

"permit.step4":
  "Site inspection by authorized officer",

"permit.step5":
  "Building permit approval and certificate issue",


// TIMELINE

"permit.timeline":
  "Processing Time",

"permit.timelineValue":
  "Building permit certificate will be issued within 7–15 working days.",


// APPLY SECTION

"permit.applyTitle":
  "Apply For Building Permit",

"permit.applyDesc":
  "Start your building construction approval process online quickly and securely.",

"permit.apply":
  "Apply Now",

  // ======================================
// ALL NEWS
// ======================================

"allNews.title":
  "Village News Updates",

"allNews.subtitle":
  "Latest announcements, updates and important news",

"allNews.emptyTitle":
  "No News Available",

"allNews.emptyDesc":
  "Admin has not added any news yet.",

  // ======================================
// VHNWSC
// ======================================

"vhnwsc.logo":
  "Health",

"vhnwsc.title":
  "Village Health Nutrition Water Supply and Sanitation Committee",

"vhnwsc.subtitle":
  "Committee working for village health, nutrition, water supply and sanitation management",

"vhnwsc.members":
  "Committee Members",

// Roles
"vhnwsc.sarpanch":
  "Sarpanch",

"vhnwsc.deputySarpanch":
  "Deputy Sarpanch",

"vhnwsc.member":
  "Member",

"vhnwsc.memberFemale":
  "Member",

"vhnwsc.officer":
  "Gram Panchayat Officer",

"vhnwsc.operator":
  "Computer Operator",
  

  
"deathForm.success.title":
  "Application Submitted!",

"deathForm.success.subtitle":
  "Application Submitted Successfully",


// Residence Certificate


"residence.title":
  "Residence Certificate",

"residence.backHome":
  "Back To Home",

"residence.card.title":
  "Get Residence Certificate from Gram Panchayat Portal",

"residence.card.desc":
  "Apply online for a residence certificate. After submission you will receive a token number. Keep it safe.",

"residence.details.title":
  "Residence Certificate",

"residence.fee":
  "Fee: ₹20",

"residence.documents":
  "Required Documents",

"residence.doc1":
  "Residence Record",

"residence.doc2":
  "Aadhaar Card",

"residence.doc3":
  "Address Proof",

"residence.process":
  "Process",

"residence.step1":
  "Apply Online",

"residence.step2":
  "Upload Documents",

"residence.step3":
  "Pay Fee",

"residence.step4":
  "Download Certificate",

"residence.timeline":
  "Timeline",

"residence.timelineValue":
  "2–3 Days",

"residence.ready":
  "Ready to Apply?",

"residence.apply":
  "Apply Now",

  // ======================================
// VWSSC
// ======================================

"vwssc.logo":
  "Water",

"vwssc.title":
  "Village Water Supply and Sanitation Committee",

"vwssc.subtitle":
  "Committee working for village water supply, sanitation and health management",

"vwssc.members":
  "Committee Members",

// Roles
"vwssc.sarpanch":
  "Sarpanch",

"vwssc.deputySarpanch":
  "Deputy Sarpanch",

"vwssc.member":
  "Member",

"vwssc.memberFemale":
  "Member",

"vwssc.officer":
  "Gram Panchayat Officer",

"vwssc.operator":
  "Computer Operator",

  // ======================================
// VCPC
// ======================================

"vcpc.logo":
  "Child Protection",

"vcpc.title":
  "Village Child Protection Committee",

"vcpc.subtitle":
  "Committee working for protection, education, health and safety of children in the village",

"vcpc.members":
  "Committee Members",

// Roles
"vcpc.sarpanch":
  "Sarpanch",

"vcpc.deputySarpanch":
  "Deputy Sarpanch",

"vcpc.member":
  "Member",

"vcpc.memberFemale":
  "Member",

"vcpc.officer":
  "Gram Panchayat Officer",

"vcpc.operator":
  "Computer Operator",

};

export default en;

